export default class Endpoints {
  static safe(endpoint) {
    return endpoint
      .split('-')
      .map(function(item) {
        return item.charAt(0).toUpperCase() + item.substring(1);
      })
      .join('');
  }
  static get List() {
    return Endpoints._list.map(obj => {
      return {
        ...obj,
        getAction: `get${Endpoints.safe(obj.slug)}`,
        listAction: `list${Endpoints.safe(obj.slug)}`,
        searchAction: `search${Endpoints.safe(obj.slug)}`,
        getProperty: `${Endpoints.safe(obj.slug)}`,
        listProperty: `${Endpoints.safe(obj.slug)}s`,
        searchProperty: `${Endpoints.safe(obj.slug)}Results`
      };
    });
  }
  static get _list() {
    return [
      {
        slug: 'hall-of-fame-inductee',
        title: 'breitbard hall of fame'
      },
      {
        slug: 'star-of-the-year',
        title: 'stars of the year'
      },
      {
        slug: 'star-of-the-month',
        title: 'stars of the month'
      },
      {
        slug: 'lifetime-achievement',
        title: 'lifetime achievement award'
      },
      {
        slug: 'ron-fowler-community-champion',
        title: 'ron fowler community champion award'
      },
      {
        slug: 'ernie-wright-humanitarian',
        title: 'ernest h. wright sr. humanitarian award'
      },
      {
        slug: 'challenged-athlete-of-the-year',
        title: 'challenged athlete of the year'
      },
      {
        slug: 'significant-achievement',
        title: 'significant achievement'
      },
      {
        slug: 'sportsperson-of-the-year',
        title: 'sports person of the year'
      },
      {
        slug: 'coaching-legend',
        title: 'san diego high school coaching legends'
      },
      {
        slug: 'official',
        title: 'san diego county sports officials hall of fame'
      }
    ];
  }
}
